import { Injectable, Output, EventEmitter } from '@angular/core';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
import { ProxyService } from '@core/services/proxy.service';

@Injectable()
export class ChildRecipeService {
  @Output() childRecipe: EventEmitter<any> = new EventEmitter<any>();
  @Output() customizationUpdate: EventEmitter<any> = new EventEmitter<any>();

  childreciepe: any;
  constructor(private proxyService: ProxyService) { }
  getChildRecipes(recipeId, locationID) {
    // const location = sessionStorage.getItem('locationId');
    // return this.proxyService.httpGet(ApiRoutes.LOCATIONS + '/' + location + '/' + ApiRoutes.CHILD_RECIPE + '/' +
    return this.proxyService.httpGet(ApiRoutes.LOCATIONS + '/' + locationID + ApiRoutes.CHILD_RECIPE + '/' +
    recipeId);
  }

  sendMessage(message: any) {
    this.childRecipe.emit(message);
  }

  sendUpdate(message: any) {
    this.customizationUpdate.emit(message);
  }

  fwtchCHildReceipie(value) {
    this.childreciepe = value;
    return this.childreciepe;
  }
}
